import { InMemoryCache } from '@apollo/client';
import merge from 'lodash/merge';
import PossibleTypesResultData from '../__generated__/PossibleTypesResultData';
import { baseTypePolicies } from './base';

export const cache: InMemoryCache = new InMemoryCache({
  typePolicies: merge(baseTypePolicies),
  possibleTypes: PossibleTypesResultData.possibleTypes,
});
